import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService as Auth0 } from '@auth0/auth0-angular';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { Auth0User } from './auth.guard';
import { UserStatusEnum } from '../user/user-status.enum';

export const passwordExpiredGuard: CanActivateFn = () => {
  const auth0 = inject(Auth0);
  const router = inject(Router);

  return auth0.isAuthenticated$.pipe(
    take(1),
    // Cached ID token claims can carry a stale status, e.g. when the password was reset in another platform,
    // so ask Auth0 for a fresh one. Without a silent session, fall back to the cached claims authGuard used.
    switchMap(isAuthenticated =>
      isAuthenticated
        ? auth0.getAccessTokenSilently({ cacheMode: 'off' }).pipe(
            catchError(() => of(null)),
            switchMap(() => auth0.user$.pipe(take(1))),
          )
        : of(null),
    ),
    map(user =>
      (user as Auth0User | null)?.user_metadata?.status === UserStatusEnum.PasswordExpired
        ? true
        : router.createUrlTree(['/']),
    ),
  );
};
